import { useEffect, useState } from "react";
import { getRequest, postRequest } from "../../globalhelper/helper";
import { CSVLink } from "react-csv";
import Checkbox from "@mui/material/Checkbox";
import moment from "moment";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Alert,
  AlertTitle,
  Box,
  Button,
  Typography,
  Grid,
  TextField,
  Autocomplete,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { useDispatch } from "react-redux";
import {
  showLoader,
  hideLoader
} from "../../redux/Common/commonActions";

import NewDynamicTable from "../Edureka/NewDynamicTable";
import { toast } from "react-toastify";

const CreateProvision = () => {

  const dispatch = useDispatch();

  const [Companies, setCompanies] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openTdsDialog, setOpenTdsDialog] = useState(false);

  const [formData, setFormData] = useState({
    company: null,
    vendor: null,
    fromDate: "",
    toDate: ""
  });

  useEffect(() => {

    getRequest("api/edureka/getCompanyAssignedToUser")
      .then(({ res }) => {
        setCompanies(res.data || []);
      })
      .catch(console.error);

    getRequest("api/edureka/getVM1")
      .then(({ res }) => {

        if (res.status === "success") {

          const temp = JSON.parse(res.data);

          const vendorList = temp
            .map(item => ({
              vendorId: item["Vendor ID"],
              vendorName: item["Vendor Name"]
            }))
            .filter(
              (item, index, self) =>
                index === self.findIndex(
                  x => x.vendorId === item.vendorId
                )
            );

          setVendors(vendorList);
        }

      })
      .catch(console.error);

  }, []);

  const handleChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

    const handleRowSelect = (index, checked) => {

    setTableData(prevData =>
        prevData.map((row, i) =>
        i === index
            ? {
                ...row,
                selected: checked
            }
            : row
        )
    );

    };

  const handleSubmit = () => {

    dispatch(showLoader());

    const formattedFromDate = moment(
            formData.fromDate,
            "YYYY-MM-DD"
        ).format("DD-MM-YYYY");

    const formattedToDate = moment(
            formData.toDate,
            "YYYY-MM-DD"
        ).format("DD-MM-YYYY");

    getRequest(
      `api/edureka/getCreateProvisionData?orgid=${formData.company?.orgid}&vendorid=${formData.vendor?.vendorId}&fromDate=${formattedFromDate}&toDate=${formattedToDate}`
    )
      .then(({ res }) => {
    const updatedData = (res.data || []).map((row, index) => {

      const percentage =
        Number(row["Percentage of TDS"] || 0);

      const provisionValue =
        Number(row["Provision_Created"] || 0) +
        Number(row["Current Provision"] || 0);

      return {
        ...row,

        "Balance Provision Available":
          row["Balance_ProvisionAmt"],

        "TDS Amount":
          (
            provisionValue *
            Math.abs(percentage)
          ) / 100,

        selected: false,
        rowId: index + 1
      };
    });
  setTableData(updatedData);
      })
      .catch(console.error)
      .finally(() => dispatch(hideLoader()));
  };

const handleSelectAll = (checked) => {

  setTableData(prevData =>
    prevData.map(row => ({
      ...row,
      selected: checked
    }))
  );

};

  const handleReset = () => {

    setFormData({
      company: null,
      vendor: null,
      fromDate: "",
      toDate: ""
    });

    setTableData([]);
  };

  const displayColumns = [
  "Sender Name",
  "Order Number",
  "DocumentType",
  "Accounting Date",
  "Line ID",
  "ForPrdFrom",
  "ForPrdTo",
  "Order Description",
  "Order Qty",
  "Balance Qty",
  "Accepted Qty",
  "This GRN/SRN Rate",
  "ToTal Provision Value",
  "Provision_Created",
  "Current Provision",
  "Provision Reversed",
  "TDS Deducted",
  "Balance Provision Available",
  "CostAllocationMethod",
  "Section Name",
  "Percentage of TDS",
  "TDS Amount"
];

const sectionOptions = [
  "194H-TDS on Commission(5%)",
  "194C-TDS on Contract-Company(2%)",
  "194C-TDS on Contract-Non Company(1%)",
  "194A-TDS on Interest(10%)",
  "194J-TDS Professional (10%)",
  "194J-TDS Professional (2%)",
  "194I-TDS Payable Rent(land/building/furniture)(10%)",
  "194I-TDS Payable Rent(plant and machinery)(2%)",
  "195-TDS U/s 195(10%)",
  "195-TDS U/s 195(20%)",
  "Equalisation Levy",
  "192-TDS On Salary(0%)"
];

const handleCreateProvision = async (
  deductTds
) => {

  try {

    let  selectedData = tableData.filter(
      row => row.selected
    );

    selectedData = selectedData.map(row => ({
      ...row,
      DeductionRef: deductTds
        ? "DeductTDS"
        : false
    }));

  console.log(
    "FINAL DATA ",
    JSON.stringify(selectedData, null, 2)
  );

  console.table(selectedData);

    if (!selectedData.length) {
      toast.warning("Please select at least one row");
      return;
    }

    dispatch(showLoader());

    // Create CSV
    const headers = Object.keys(selectedData[0])
      .filter(
        key =>
            key !== "selected" &&
            key !== "rowId"
        )

    const csvContent = [
      headers.join(","),
      ...selectedData.map(row =>
        headers
          .map(h => `"${row[h] ?? ""}"`)
          .join(",")
      )
    ].join("\n");

    // Create File
    const blob = new Blob(
      [csvContent],
      { type: "text/csv" }
    );

    const file = new File(
      [blob],
      "CreateProvision.csv",
      { type: "text/csv" }
    );

    // FormData
    const uploadFormData = new FormData();

    uploadFormData.append(
      "file",
      file
    );

    const encodedThemeName =
      encodeURIComponent("G&SRNIV1");

    const response = await postRequest(
      `api/upload/singleUpload2?OrgID=${formData.company?.orgid || ""}
      &TransactionType=GRN
      &ThemeName=${encodedThemeName}
      &GSTIN=
      &From=${formData.fromDate}
      &To=${formData.toDate}
      &ProcessCode=BT3I`
        .replace(/\s+/g, ""),
      uploadFormData
    );

    console.log(response);

    toast.success(
      "Provision uploaded successfully"
    );

  } catch (err) {

    console.error(err);

    toast.error(
      "Failed to create provision"
    );

  } finally {

    dispatch(hideLoader());

  }
};

useEffect(() => {
  console.log(tableData);
}, [tableData]);

  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography variant="h6">
            Create Provision
          </Typography>
        </AccordionSummary>

        <AccordionDetails>

          <Grid container spacing={2}>

            <Grid item xs={12} md={3}>
              <Autocomplete
                size="small"
                value={formData.company}
                options={Companies}
                getOptionLabel={(option) =>
                  option?.orgname || ""
                }
                onChange={(e, value) =>
                  handleChange("company", value)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Company"
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <Autocomplete
                size="small"
                value={formData.vendor}
                options={vendors}
                getOptionLabel={(option) =>
                  `${option.vendorName}`
                }
                onChange={(e, value) =>
                  handleChange("vendor", value)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Vendor"
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="For Period From"
                InputLabelProps={{
                  shrink: true
                }}
                value={formData.fromDate}
                onChange={(e) =>
                  handleChange(
                    "fromDate",
                    e.target.value
                  )
                }
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="For Period To"
                InputLabelProps={{
                  shrink: true
                }}
                value={formData.toDate}
                onChange={(e) =>
                  handleChange(
                    "toDate",
                    e.target.value
                  )
                }
              />
            </Grid>

            <Grid item>

              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={
                  !formData.company ||
                  !formData.vendor ||
                  !formData.fromDate ||
                  !formData.toDate
                }
              >
                Submit
              </Button>

              <Button
                color="error"
                variant="contained"
                sx={{ ml: 1 }}
                onClick={handleReset}
              >
                Reset
              </Button>

              {tableData.length > 0 && (
                <Button
                  color="success"
                  variant="contained"
                  sx={{ ml: 1 }}
                >
                  <CSVLink
                    data={tableData}
                    filename="Create_Provision.csv"
                    style={{
                      color: "white",
                      textDecoration: "none"
                    }}
                  >
                    Download
                  </CSVLink>
                </Button>
                
              )}

            {tableData.some(row => row.selected) && (
            <Button
                color="primary"
                variant="contained"
                sx={{ ml: 1 }}
                onClick={() => {
                  const selectedData =
                    tableData.filter(row => row.selected);

                  if (!selectedData.length) {
                    toast.warning(
                      "Please select at least one row"
                    );
                    return;
                  }
                  setOpenTdsDialog(true);
                }}
            >
                Create Provision
            </Button>
            )}

            </Grid>

          </Grid>

        </AccordionDetails>
      </Accordion>

    {tableData.length ? (
    <TableContainer
        component={Paper}
        sx={{ mt: 2 }}
    >
        <Table size="small">

        <TableHead>
          <TableRow>

            <TableCell>
              <Checkbox
                checked={
                  tableData.length > 0 &&
                  tableData.every(row => row.selected)
                }
                indeterminate={
                  tableData.some(row => row.selected) &&
                  !tableData.every(row => row.selected)
                }
                onChange={(e) =>
                  handleSelectAll(e.target.checked)
                }
              />
            </TableCell>

            {displayColumns.map((column) => (
              <TableCell key={column}>
                {column}
              </TableCell>
            ))}

          </TableRow>
        </TableHead>

        <TableBody>

            {tableData.map((row, index) => (

            <TableRow key={row.rowId}>

                <TableCell>
                    <Checkbox
                    checked={!!row.selected}
                    onClick={() =>
                        handleRowSelect(
                        index,
                        !row.selected
                        )
                    }
                    />
                </TableCell>

{displayColumns.map((column) => (

  <TableCell key={column}>

    {column === "Section Name" ? (

      <Select
        size="small"
        value={row["Section Name"] || ""}
        onChange={(e) => {
          const value = e.target.value;

          setTableData(prev =>
            prev.map((r, i) =>
              i === index
                ? {
                    ...r,
                    "Section Name": value
                  }
                : r
            )
          );
        }}
      >
        {[
          row["Section Name"],
          ...sectionOptions.filter(
            option => option !== row["Section Name"]
          )
        ].map(option => (
          <MenuItem
            key={option}
            value={option}
          >
            {option}
          </MenuItem>
        ))}
      </Select>

    ) : column === "Percentage of TDS" ? (

      <TextField
        size="small"
        type="number"
        value={row["Percentage of TDS"] ?? ""}
        onChange={(e) => {

          const value = e.target.value;

          if (
            value === "" ||
            /^-?\d*$/.test(value)
          ) {

            setTableData(prev =>
              prev.map((r, i) =>
                i === index
                  ? {
                      ...r,
                      "Percentage of TDS": value,
                      "TDS Amount":
                        (
                          (
                            Number(r["Provision_Created"] || 0)
                            +
                            Number(r["Current Provision"] || 0)
                          )
                          *
                          Math.abs(Number(value || 0))
                        ) / 100
                    }
                  : r
              )
            );

          }

        }}
      />

    ) : (

      row[column]

    )}

  </TableCell>

))}

            </TableRow>

            ))}

        </TableBody>

        </Table>
        <Dialog
  open={openTdsDialog}
  onClose={() => setOpenTdsDialog(false)}
>
  <DialogTitle>
    Are you sure you want to deduct TDS?
  </DialogTitle>

  <DialogActions>

    <Button
      onClick={() => {
        setOpenTdsDialog(false);
        handleCreateProvision(true);
      }}
    >
      Yes
    </Button>

    <Button
      onClick={() => {
        setOpenTdsDialog(false);
        handleCreateProvision(false);
      }}
    >
      No
    </Button>

  </DialogActions>
</Dialog>
    </TableContainer>

    
    ) : (
        <Box sx={{ mt: 2 }}>
          <Alert severity="warning">
            <AlertTitle>No Data Found</AlertTitle>
            There is no data to display.
          </Alert>
        </Box>
      )}
    </>
  );
};

export default CreateProvision;